import { render, staticRenderFns } from "./SmallPaginator.vue?vue&type=template&id=07eff5ef&scoped=true"
import script from "./SmallPaginator.vue?vue&type=script&lang=js"
export * from "./SmallPaginator.vue?vue&type=script&lang=js"
import style0 from "./SmallPaginator.vue?vue&type=style&index=0&id=07eff5ef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07eff5ef",
  null
  
)

export default component.exports